export default __webpack_public_path__ + "static/media/330_dummy2016-beauty02-de.c9f954f1.png";